import type { FaireProductEntity } from "../../entity_types/product";

export const p_wbdvrtkwfm: FaireProductEntity = {
  token: "p_wbdvrtkwfm",
  type: "product",
  name: "LE GRAND 29 PALMS",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/24c70de77f69e2c73207c25ef9bd3f19972a3b28163ad6b664a59cefd18f09d8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa02a15d3f6327b81f29351f07c5c54256a65fd8c9504b1864d43537c37df49c.jpeg",
    "https://cdn.faire.com/fastly/8382a8daaab659e4c0a91150454eae9bb3f882acc731add07384e0a7b6592e47.jpeg"
  ],
  priceDollars: 30,
  description: "Meet our new Le Grand 29 Palms, 14 oz of your favorite scent is finally here!\n\nCapturing the essence of the cool morning desert air after rainfall. Pure and simple in nature, this scent opens with the soothing fragrance of eucalyptus and desert sage atop woody base notes of cedar and palo santo and finished with the delicate nuance of rain accord.\n\ndesert sage, cedar, eucalyptus, palo santo, white musk\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n14 ounces (397g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:07.557Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
